export default __webpack_public_path__ + "static/media/app_active-users_banner.1e3b1acf.jpg";